.Confetti {
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 1000;
}

.piece {
    position: absolute;
    top: -20px;
    left: var(--confetti-left);
    width: var(--confetti-size);
    height: var(--confetti-size);
    background-color: var(--confetti-color);
    animation: confetti-fall var(--confetti-duration) ease-out var(--confetti-delay) forwards;
    transform: rotate(var(--confetti-rotation));
    opacity: 1;
}

.pieceRect {
    width: calc(var(--confetti-size) * 0.4);
    height: var(--confetti-size);
    border-radius: 2px;
}

.pieceCircle {
    border-radius: 50%;
}

.pieceSquare {
    border-radius: 2px;
}

@keyframes confetti-fall {
    0% {
        transform: translateY(0) rotate(var(--confetti-rotation)) scale(1);
        opacity: 1;
    }
    75% {
        opacity: 1;
    }
    100% {
        transform: translateY(100vh) rotate(calc(var(--confetti-rotation) + 720deg)) scale(0.5);
        opacity: 0;
    }
}
